<!--TODO: uncomment back when API part will be ready-->
@if (rates) {
  <pp-rates [rates]="rates()" />
}
<!--<pp-tabs-->
<!--  class="tabs margin-auto"-->
<!--  [tabs]="tabs"-->
<!--  (index)="setTab($event)" />-->

<!--  @switch (index()) {-->
<!--    @case (exchangeRateScreen.rates) {-->
<!--      <pp-rates [rates$]="rates$"/>-->
<!--    } @case (exchangeRateScreen.currencyMarket) {-->
<!--    } @case (exchangeRateScreen.cryptoMarket) {-->
<!--      <pp-crypto-market-->
<!--        [cryptoMarket$]="cryptoMarket$"-->
<!--        [cryptoMarketFilter$]="cryptoMarketFilter$"-->
<!--        [columns]="columns"/>-->
<!--    }-->
<!--  }-->
